module.exports = __webpack_public_path__ + "static/media/qratalogo.a815a1b2.png";